// ── ParentDashboardStrip ✦ — Phase D internal-only adoption strip ─
//
// Aggregate counts ONLY — no per-parent visibility, no funnel
// metrics, no engagement framing. Operational awareness, not
// behavioural analytics. Constitutional rules locked 2026-05-20.
// Backend contract: GET /api/crew/admin/parent-dashboard-metrics.
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Users, Heart, ArrowsClockwise, Lifebuoy } from '@phosphor-icons/react';
import { API, TEXT_MUTED, BLUE, PURPLE, PINK, SAGE } from './palette';
import { MetricsTile } from './MetricsTile';

export const ParentDashboardStrip = ({ onJump }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/crew/admin/parent-dashboard-metrics`);
        setData(r.data || {});
      } catch {
        // Best-effort — never blocks the rest of the admin panel.
        setData({});
      } finally { setLoading(false); }
    })();
  }, []);

  if (loading) return null;
  const d = data || {};
  return (
    <div data-testid="admin-parent-dashboard-strip" style={{ marginTop: 28 }}>
      <p style={{
        margin: '0 0 4px', fontWeight: 800, fontSize: 10.5, letterSpacing: '0.3em',
        textTransform: 'uppercase', color: TEXT_MUTED,
      }}>
        ✦ Parent Dashboards
      </p>
      <p style={{ margin: '0 0 14px', color: TEXT_MUTED, fontSize: 12.5, lineHeight: 1.55 }}>
        Aggregate ecosystem health — never per-parent ✦
      </p>
      <div style={{ display: 'grid', gap: 10, gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))' }}>
        <MetricsTile
          label="Active ✦"
          value={d.dashboards_active ?? '—'}
          icon={Users} accent={BLUE}
          testid="admin-parent-dashboards-active"
          onClick={() => {}}
        />
        <MetricsTile
          label="Opens · 7d"
          value={d.opens_this_week ?? '—'}
          icon={Heart} accent={PINK}
          testid="admin-parent-dashboard-opens-week"
          onClick={() => {}}
        />
        <MetricsTile
          label="Extensions · 30d"
          value={d.extensions_this_month ?? '—'}
          icon={ArrowsClockwise} accent={PURPLE}
          testid="admin-parent-dashboard-extensions-month"
          onClick={() => {}}
        />
        <MetricsTile
          label="DSL requests · 30d"
          value={d.dsl_requests_this_month ?? '—'}
          icon={Lifebuoy} accent={SAGE}
          testid="admin-parent-dashboard-dsl-requests-month"
          onClick={() => onJump?.('safeguarding')}
        />
      </div>
    </div>
  );
};
